import { sagas as slotsRecommendationsSagas } from 'framework/modules/merchandising/common/Recommendations/store';
import { sagas as listingsSaveSagas } from 'framework/modules/merchandising/common/Listings/store';
import { sagas as listingsListSagas } from 'framework/modules/merchandising/pages/ListingsList/store';

export default [
  ...slotsRecommendationsSagas,
  ...listingsSaveSagas,
  ...listingsListSagas,
];
